import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-current-user',
  templateUrl: './current-user.component.html',
  styleUrls: ['./current-user.component.scss'],
  encapsulation : ViewEncapsulation.Emulated
})

export class CurrentUserComponent implements OnInit {

  user = {
    email: '',
    password: ''
  };
  loginError: string | null = null;

  constructor(public auth: AngularFireAuth, private router: Router) {}

  signInWithEmail() {
    this.loginError = null;
    this.auth.signInWithEmailAndPassword(this.user.email, this.user.password)
      .then((res) => {
        console.log('logged in');

       this.router.navigate(['home']);
      })
      .catch((err) => {
        this.loginError = 'Login failed. Please check your credentials.';
        console.log('error: ' + err);
      });
  }

  logout() {
    this.auth.signOut();
  }

  ngOnInit(): void {
  }

}
